exports.linkResolver = (doc) => {
  if (doc.type === 'article') {
    return `/news/${doc.uid}/`;
  }
  if (doc.type === 'case_study') {
    return `/technical-assistance/case-studies/${doc.uid}/`;
  }
  if (doc.type === 'story') {
    return `/impact/meet-our-clients/${doc.uid}/`;
  }
  if (doc.type === 'person') {
    return '/about/team/';
  }
  if (doc.type === 'company') {
    if (doc.data.type === 'investee') {
      return '/partners/investees/';
    }
    return '/partners/investors/';
  }
  if (doc.type === 'page') {
    switch (doc.id) {
      case 'X6_DxBIAACcAP7w5':
        return '/about/';
      case 'X8UTfxYAACsAp1rb':
        return '/about/fact-sheet/';
      case 'X6_QZhIAACYAP_Pj':
        return '/about/investment-criteria/';
      case 'X8TXqxYAACsApk5k':
        return '/about/team/';
      case 'Yby03BEAACEA1ge5':
        return '/about/sustainable-finance-disclosures/';
      case 'X8UFHxYAACwApxnb':
        return '/impact/';
      case 'X8UGjBYAACwApyBO':
        return '/impact/meet-our-clients/';
      case 'X8UF_BYAAC0Apx25':
        return '/impact/social-reports/';
      case 'X8T73hYAACsApvCt':
        return '/partners/';
      case 'X8T9MRYAACoApvaT':
        return '/partners/investees/';
      case 'X8T-_RYAACoApv6b':
        return '/partners/investors/';
      case 'Zx5ZihEAACAAFKG2':
        return '/news/';
      case 'Zx5arREAAB4AFKNe':
        return '/videos/';
      case 'X8T3XxYAACoAptyT':
        return '/in-the-media/';
      case 'Zx5Y_xEAACAAFKDq':
        return '/contact/';
      case 'Zx5YahEAACEAFKAX':
        return '/complaints/';
      case 'Zx5V0xEAAB8AFJx2':
        return '/cookie-policy/';
      case 'aj1W_BIAACwAWNng':
        return '/technical-assistance/';
      case 'aj1h_BIAACcAWOrk':
        return '/technical-assistance/terms-of-reference/';
      default:
        return '';
    }
  }
};
